import { getEnv } from "@ace/env";
import { Stack } from "@mui/material";
import { ErrorBoundary as EB } from "react-error-boundary";
import ErrorOutline from "@mui/icons-material/ErrorOutline";

function fallbackRender() {
  return (
    <Stack p={1} flexDirection={"row"} gap={1} m={2}>
      <ErrorOutline
        color="error"
        sx={{ cursor: "pointer", width: 20, mb: "2px" }}
      />
      <span>
        An error has occurred. <br /> If this issue persists, please contact{" "}
        <a href={`mailto:${getEnv("ARCHAX_EMAIL_SUPPORT")}`}>
          {getEnv("ARCHAX_EMAIL_SUPPORT")}
        </a>{" "}
      </span>
    </Stack>
  );
}

const ErrorBoundary = ({ children }: { children: React.ReactNode }) => {
  return <EB fallbackRender={fallbackRender}>{children}</EB>;
};

const errorBoundary = (component: any) => {
  return (
    <EB key={component.type.name} fallbackRender={fallbackRender}>
      {component}
    </EB>
  );
};

export { ErrorBoundary, errorBoundary };
